import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse,
  HttpHandler,
  HttpEvent
} from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import * as CryptoJS from 'crypto-js';
import * as _ from 'underscore';

import { config } from './app.config';
import { AuthService } from './auth-service.service';

const secretKey = config.SECRETKEY;

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  private readonly modelUrl = 'llmgpt.canstringai.com';

  constructor(
    private authService: AuthService,
    private router: Router
  ) { }

  private modifyBody(body: any): any {
    try {
      if (_.isObject(body) && body?.encData) {
        const bytes = CryptoJS.AES.decrypt(body.encData, secretKey);
        const decryptedText = bytes.toString(CryptoJS.enc.Utf8);

        if (decryptedText) {
          return JSON.parse(decryptedText);
        }
      }
    } catch (error) {
      console.error('Response decryption failed:', error);
    }

    return body;
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    const token = this.authService.getToken();
    let newReq = req;

    // Encrypt request body
    if (
      req.body &&
      !(req.body instanceof FormData) &&
      _.isObject(req.body) &&
      config.HOST === config.DOMAIN_NAME &&
      !req.reportProgress
    ) {
      const encryptedBody = {
        encData: CryptoJS.AES.encrypt(
          JSON.stringify(req.body),
          secretKey
        ).toString()
      };

      newReq = req.clone({
        body: encryptedBody
      });
    }

    // Prepare headers
    const headers: Record<string, string> = {};

    if (token) {
      headers['x-auth-token'] = token;
    }

    if (req.url.includes('.mp3')) {
      headers['Range'] = 'bytes=0-1023';
    }

    const llmToken = localStorage.getItem('llm_token');

    if (llmToken) {
      headers['Authorization'] = `Bearer ${llmToken}`;
    }

    if (Object.keys(headers).length) {
      newReq = newReq.clone({
        setHeaders: headers
      });
    }

    return next.handle(newReq).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          return event.clone({
            body: this.modifyBody(event.body)
          });
        }

        return event;
      }),

      catchError((error: HttpErrorResponse) => {

        if (
          error.status === 401 &&
          !error.url?.includes(this.modelUrl)
        ) {
          localStorage.clear();
          this.router.navigate(['/login']);
        }

        if (
          error.status === 403 &&
          !error.url?.includes(this.modelUrl)
        ) {
          this.router.navigate(['/verify_otp']);
        }

        if (error.status === 421) {
          this.router.navigate(['/askquestions']);
        }

        return throwError(() => error);
      })
    );
  }
}